import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { database } from 'firebase';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { ValidationService } from '../validation.service';
import { Messages } from '../constants/messages';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { StorageService } from '../storage.service';
import { TranslateService } from '@ngx-translate/core';
import { DateTime, Duration } from 'luxon';
import { HolidayListComponent } from '../holiday-list/holiday-list.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
export interface shipperPrefix {
  SIN_code: string;
}
export interface shipperCounter {
  counter: number;
}
export interface counterLr {
  lr_seq: number;
  custom_CWB_enabled: boolean;
}
export interface counterFreight {
  freight_invoice_seq: number;
}
export interface counterBill {
  bill_seq: number;
}
export interface supportMobile {
  support_no: String;
}
export interface supportEmail {
  support_email: String;
}

export interface waybillSequence {
  'custom_CWB_enabled': boolean;
  'custom_range': {
    'from': number;
    'to': number;
  };
  'custom_text': string;
}
@Component({
  selector: 'app-unit-settings',
  templateUrl: './unit-settings.component.html',
  styleUrls: ['./unit-settings.component.scss']
})
export class UnitSettingsComponent implements OnInit {



  @ViewChild('confirmDialog', { static: true }) confirmDialog: TemplateRef<any>;
  @ViewChild('logoPreviewDialog', { static: true }) logoPreviewDialog: TemplateRef<any>;

  selectedSpotGPS = [];
  selectedOwnGPS = [];
  spot_gps_list = ['None'];
  own_gps_list = ['None'];
  idleTimer = 45;
  tickInterval = 15;
  disableNumber = false;

  billing_address = '';
  sinCode: shipperPrefix = {
    SIN_code: ''
  };
  holidays = [];
  holidaysList = [];
  displayColumns = ['slno','holiday','date','action'];

  holiday_description = '';
  holiday_date:any = {
    date:'',
    date_ts:''
  };
  counter: shipperCounter = {
    counter: 0
  };
  lrSeq: counterLr = {
    lr_seq: 0,
    custom_CWB_enabled: false
  };
  freightSeq: counterFreight = {
    freight_invoice_seq: 0
  };
  billSeq: counterBill = {
    bill_seq: 0
  };
  mobile: supportMobile = {
    support_no: ''
  };
  checked = false;
  email: supportEmail = {
    support_email: ''
  };
  disablePrefix =  false;
  disableCounter = false;
  disableLr = false;
  disableFreight = false;
  disableBill = false;
  success = false;
  showLoader = false;
  carrier_code: any;
  waybillSequence: waybillSequence = {
    custom_CWB_enabled: true,
    custom_range: {
      from: 0,
      to: 0
    },
    custom_text: '',
  };
  vehicle_types = [];
  vehicles = [];
  preselectedvehicles = [];
  carrier_unit = '';
  isc_code = '';
  logo = '';
  logoPreviewDialogRef;
  searchInput = '';
  filteredVehicles = [];
  selectedVehicleNames = [];

  carrierId: Subscription;
  messages = new Messages();
  helpData = [
    { head: 'Help', data: 'Manage various Units. Allows to change, add or edit any changes on Unit name, Locations, User or user roles.' },
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private storage: StorageService ,private translate: TranslateService, private translation: TranslateService, private http: HttpService, private snackbar: SnackbarService, private dialog: MatDialog, private events: EventService, private valid: ValidationService) { }

  ngOnInit() {
    this.idleTimer = parseInt(localStorage.getItem('idleTime')) || 45;
    
    this.getData();
    this.initvehicles();
    this.getCarrierVehicleTypes();
    this.getGPSProviders();
    const carriers = JSON.parse(this.storage.getFromLocalStorage('carriers'));
    this.carrier_unit = carriers[0].parent_name + ' - ' + carriers[0].name;
    this.carrier_code = carriers[0].short_code;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getData();
        const selectedCarrier = carriers.filter((carrier) => {
          if(carrier){
            return carrier._id === data.carrier_id;
          }
        });
        this.carrier_code = selectedCarrier[0].short_code;
        this.carrier_unit = selectedCarrier[0].parent_name + ' - ' + selectedCarrier[0].name;
      }
    );
  }
  changeIdleTimer() {
    this.events.setIdleTimer(this.idleTimer);
    localStorage.setItem('idleTime', '' + this.idleTimer);
    this.snackbar.openSnackBar('Idle Time Updated to '+ this.idleTimer +' mins', '', '');
  }
  getSliderTickInterval(): number | 'auto' {
    return this.tickInterval;
  }

  selectvehicle(event, vehicle) {
    if (event.source && event.source.selected && this.vehicle_types.indexOf(vehicle._id) == -1) {
      this.vehicle_types.push(vehicle._id);
      this.selectedVehicleNames.push(vehicle.name);
    } else if (this.vehicle_types.indexOf(vehicle._id) != -1) {
      this.vehicle_types.splice(this.vehicle_types.indexOf(vehicle._id), 1);
      this.selectedVehicleNames.splice(this.selectedVehicleNames.indexOf(vehicle.name), 1);
    }
    console.log(this.vehicle_types);
  }

  initvehicles() {
    this.http.get('vehicle_type/all').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          const result = data.data;
          if (result && result.length) {
            result.forEach(element => {
              const temp: any = {
                _id: '',
                name: ''
              };
              temp._id = element._id;
              temp.name = element.name;
              this.vehicles.push(temp);
            });
            this.filteredVehicles = this.vehicles;
          }
        }
      }
    );
  }

  handleSearchFilter(){
    console.log(this.searchInput);
    if(this.searchInput){
      this.filteredVehicles = this.vehicles.filter((vehicle)=>{
        return vehicle.name.toLowerCase().includes(this.searchInput.toLowerCase());
      });
    }else{
      this.filteredVehicles = this.vehicles;
    }
  }
  

  getCarrierVehicleTypes() {
    this.showLoader = true;
    this.http.get('carrier_pref').subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response.statusCode == 200) {
          this.preselectedvehicles = response.data.vehicle_types.map(e => e._id);
        }
      },
      (err)=>{
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message,'','err');
      }
    );
  }

  fileChanged(event: any) {
    if (event.target.files.length) {
      const formData: any = new FormData();
      formData.append('logo', event.target.files[0], event.target.files[0].name);
      this.showLoader = true;
      this.http.upload('constants/logo', formData).subscribe(
        (response: any) => {
          this.showLoader = false;
          if (response.statusCode == 200) {
            this.snackbar.openSnackBar('Logo updated successfully');
            this.getData();
          } else {
            this.snackbar.openSnackBar('Something went wrong. Please try again later','','err');
          }
        },
        (err)=>{
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message,'','err');
        }
      );
    }
  }

  submitVehicleTypes() {
    const request: any = {
      vehicle_types : this.vehicle_types
    };
    if (this.vehicle_types.length) {
      this.showLoader = true;
      this.http.post('carrier/attach_vehicle_types', request).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.showLoader = false;
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.VEHICLE_TYPES'));
          this.getCarrierVehicleTypes();
          this.checked = false;
        }
      },
      (err) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      });
    } else {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNT_SETTINGS.VEHICLE_TYPES_EMPTY'), '', 'err');
    }

  }

  getData() {
    this.showLoader = true;
    this.http.get('constants').subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          const result = data.data;
          this.sinCode.SIN_code = result.SIN_code;
          this.counter.counter = result.counter;
          // waybill settings
          this.waybillSequence.custom_CWB_enabled = result.way_bill.custom_CWB_enabled;
          if (this.waybillSequence.custom_CWB_enabled) {
            this.waybillSequence.custom_range.to = (result.way_bill && result.way_bill.custom_range && result.way_bill.custom_range.to ) ? result.way_bill.custom_range.to : '';
            this.waybillSequence.custom_range.from = (result.way_bill && result.way_bill.custom_range && result.way_bill.custom_range.from ) ? result.way_bill.custom_range.from : '';
            this.waybillSequence.custom_text = (result.way_bill  && result.way_bill.custom_text ) ? result.way_bill.custom_text : '';
          } else {
            this.lrSeq.lr_seq = this.carrier_code + result.way_bill.seq;
          }
          this.freightSeq.freight_invoice_seq = result.freight_invoice_seq;
          this.billSeq.bill_seq = result.bill_seq;
          this.mobile.support_no = result.support_no;
          if(result.support_emails){
            this.email.support_email = result.support_emails.length ? result.support_emails.toString() : '';
          }
          this.disablePrefix =  result.SIN_code ? true : false;
          this.disableCounter = result.counter ? true : false;
          this.disableFreight = result.freight_invoice_seq ? true : false;
          this.holidays =  (result.holidays && result.holidays.length) ? result.holidays : [];            
          this.holidaysList = [];
          this.holidays.forEach((holiday,index)=>{
            let temp:any = {};

            temp.index = index + 1;
            temp.holiday = holiday.name;
            temp.date_ = new Date(holiday.year,(holiday.month - 1),holiday.day);
            temp.date = DateTime.fromJSDate(temp.date_).toFormat('dd-MMM-yyyy').toLocaleString();
            temp.id = holiday._id;
            this.holidaysList.push(temp);
          });
          if(data.data.gps && data.data.gps.length){
            this.selectedOwnGPS = data.data.gps.map((provider)=>{
              return provider.name;
            });
          }
          if(data.data.spot_gps && data.data.spot_gps.length){
            this.selectedSpotGPS = data.data.spot_gps.map((provider)=>{
              return provider.name;
            });
          }

          this.disableBill = result.bill_seq ? true : false;
          this.isc_code = result.carrier.isc;
          this.logo = data.data.logo ? data.data.logo : '';

        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  updateWaybillSeq() {
    this.showLoader = true;
    this.waybillSequence.custom_CWB_enabled = true;
    this.http.put('constants/custom_waybill_seq', this.waybillSequence).subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.ACCOUNTSETTINGS.waybillSeq'), '');
          this.getData();
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  addHolidays(){
    const dialogRef = this.dialog.open(HolidayListComponent,{
      data:this.holidays
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.statusCode == 200){
        this.getData();
      }
    });
  }

  editHoliday(element){
    let data = this.holidays.filter((e)=>{
      return e._id !== element.id
    });
    const dialogRef = this.dialog.open(HolidayListComponent,{
      data:{
        holidays:data,
        element:element
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.statusCode == 200){
        this.getData();
      }
    });
  }

  deleteHoliday(element){
    let data = this.holidaysList.filter((e)=>{
      return e.id !== element.id
    });

    data = data.map((e)=>{
      return {
        date:e.date,
        name:e.holiday
      }
    })
    const dialogData: any = {};

    dialogData.name = 'Delete Holiday';
    dialogData.type = 'delete_holiday';
    dialogData.text = 'Are you sure you want to delete this holiday';
    dialogData.url = 'fleet_settings/holidays';
    dialogData.dataToSend = data;
    const dialogRef = this.dialog.open(ConfirmationModalComponent,{
      data:dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.statusCode == 200){
        this.getData();
      }
    });
  }

  submitPrefix() {
   if (!this.disablePrefix) {
    const dialogRef = this.dialog.open(this.confirmDialog);
    dialogRef.afterClosed().subscribe(
      (dataa: any) => {
          this.http.put('constants/SIN_code?SIN_code=' + this.sinCode.SIN_code).subscribe(
            (data: any) => {
              if (data.statusCode === 200) {
                this.success = false;
                this.disablePrefix = true;
                this.snackbar.openSnackBar(this.messages.unitSettings.success.sinCode, '');
              }
            },
            (err: any) => {
              this.snackbar.openSnackBar(err.error.message, '', 'err');
            }
          );
      }
    );
   }
  }
  submitCounter() {
      if (!this.disableCounter) {
      const dialogRef = this.dialog.open(this.confirmDialog);
      dialogRef.afterClosed().subscribe(
        (dataa: any) => {
            this.http.put('constants/counter?counter=' + this.counter.counter).subscribe(
              (data: any) => {
                if (data.statusCode === 200) {
                  this.success = false;
                  this.disableCounter = true;
                  this.snackbar.openSnackBar(this.messages.unitSettings.success.counter, '');
                }
              },
              (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
              }
            );
        }
      );
    }
  }

  submitFreight() {
    if (!this.disableFreight) {
      const dialogRef = this.dialog.open(this.confirmDialog);
      dialogRef.afterClosed().subscribe(
        (dataa: any) => {
            this.http.put('constants/freight_invoice_seq?freight_invoice_seq=' + this.freightSeq.freight_invoice_seq).subscribe(
              (data: any) => {
                if (data.statusCode === 200) {
                  this.success = false;
                  this.disableFreight = true;
                  this.snackbar.openSnackBar(this.messages.unitSettings.success.freight, '');
                }
              },
              (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
              }
            );
        }
      );
    }
  }
  submitBill() {
    if (!this.disableBill) {
    const dialogRef = this.dialog.open(this.confirmDialog);
    dialogRef.afterClosed().subscribe(
      (dataa: any) => {
          this.http.put('constants/bill_seq?bill_seq=' + this.billSeq.bill_seq).subscribe(
            (data: any) => {
              if (data.statusCode === 200) {
                this.success = false;
                this.disableBill = true;
                this.snackbar.openSnackBar(this.messages.unitSettings.success.billSeq, '');
              }
            },
            (err: any) => {
              this.snackbar.openSnackBar(err.error.message, '', 'err');
            }
          );
      }
    );
  }
}
  submitMobile() {
    if (!this.valid.isEmpty(this.mobile.support_no)) {
      this.http.post('settings/support_no', this.mobile).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.messages.unitSettings.success.mobile, '');
            this.getData();
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.snackbar.openSnackBar(this.messages.unitSettings.validation.mobile, '', 'err');
      return;
    }
  }
  submitEmail() {
    const data = {
      support_emails: this.email.support_email.split(',')
    };
    let valid = true;
    data.support_emails.forEach(email => {
      if (!this.valid.isEmail(email)) {
        valid = false;
        return;
      }
    });
    if (valid) {
      this.http.post('settings/support_emails', data).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.messages.unitSettings.success.email, '');
            this.getData();
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.snackbar.openSnackBar(this.messages.unitSettings.validation.email, '', 'err');
      return;
    }
  }
  closeDialog() {
    this.dialog.closeAll();
  }

  openLogoPreview(){
    this.logoPreviewDialogRef = this.dialog.open(this.logoPreviewDialog);
  }

  getGPSProviders(){
    const payload = {
      name:'gps_providers'
    }
    this.http.get('constants/get_gps_providers',payload).subscribe((response:any)=>{
      if(response.statusCode == 200){
        const data = response.data;
        this.own_gps_list = this.own_gps_list.concat(data[0].value)
        this.spot_gps_list = this.spot_gps_list.concat(data[0].value)
      }
    },
    (err: any) => {
      this.snackbar.openSnackBar(err.error.message, '', 'err');
    })
  }
  updateOwnFleetGPSProviders(){
    const payload = {
      gps:this.selectedOwnGPS
    }
    if(payload.gps){
      this.http.post('settings/update_own_fleet_gps',payload).subscribe((response:any)=>{
        if(response.statusCode == 200){
          this.snackbar.openSnackBar(this.translate.instant('MESSAGE.UNIT_SETTINGS.SUCCESS.OWN_FLEET_GPS'));
          this.getData();
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
    }else{
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.UNIT_SETTINGS.VALIDATION.OWN_FLEET_GPS'),'','err');
    }
  }

  updateSpotGPSProviders(){
    const payload = {
      spot_gps:this.selectedSpotGPS
    }
    if(payload.spot_gps){
      this.http.post('settings/update_spot_gps',payload).subscribe((response:any)=>{
        if(response.statusCode == 200){
          this.snackbar.openSnackBar(this.translate.instant('MESSAGE.UNIT_SETTINGS.SUCCESS.SPOT_GPS'));
          this.getData();
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
    }else{
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.UNIT_SETTINGS.VALIDATION.SPOT_GPS'),'','err');
    }
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
